#import "~/graphql/fragments/sections/default/baseEntryFields.graphql"
#import "~/graphql/fragments/assets/image.graphql"

fragment globalVideoSection on globalVideo_Entry
{
    ... baseEntryFields
    featuredImage {
        ... image
    }
    vimeoUrl
    accessibleVimeoUrl
    orientation
    label
    externalUrl
}
